// extracted by mini-css-extract-plugin
module.exports = {"circle":"Avatar_circle__3pEOe","initials":"Avatar_initials__uBLka","profilePicture":"Avatar_profilePicture__ImSjF"};